import React from 'react'
import Headtitle from "../../Components/HeadTitle/Headtitle"
import AllBlogs from './AllBlogs';

import "../Blogs/Blogs.scss";

function Blogs() {
  return (
    <>
    <Headtitle/>
    <AllBlogs/>
    </>
  )
}

export default Blogs;